import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { FormGenerator } from '@microservices/wiskey-react-components'
import { Box, Typography } from '@mui/material'

import { Prefilter } from '@pages/EntityCreateOrEdit/components/EntityConfiguration/components'

import { CommandParameters } from '@components/CommandParameters'
import { ConfigRestrictions } from '@components/ConfigRestrictions/ConfigRestrictions'
import { SwitchTable } from '@components/SwitchTable'
import { Tab, TabPanel, Tabs } from '@components/Tabs'

import { MODEL_TYPE, REGEX, TIMELINE_ACTION_COLUMNS, TYPES_SOURCE_OPTIONS } from '@constants'
import { TIMELINE_COLUMNS } from '@constants'

import { getIsErrorTab } from '@gantt/helpers'

import { PageContext } from '../../TimeLineCreateOrEdit'

export const ObjectYConfiguration = () => {
  const { state, handlers, inputs } = useContext(PageContext)
  const { t } = useTranslation()

  const {
    objectYCurrentTab,
    watchObjectYPreFilter,
    watchObjectYObject,
    watchObjectYCommandCode,
    watchObjectYColumns,
    watchObjectViewId,
    watchObjectYActions,
    objectYShowAddColumnDialog,
    objectYShowAddActionDialog,
    watchId,
    methods: {
      formState: { errors },
    },
  } = state

  const {
    handleChangeObjectYPreFilter,
    handleOpenObjectYAddColumnDialog,
    handleChangeObjectYCurrentTab,
    handleDeleteObjectYColumn,
    handleOpenObjectYAddActionDialog,
    handleDeleteObjectYAction,
  } = handlers

  const { objectYInputs } = inputs

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={objectYCurrentTab} onChange={handleChangeObjectYCurrentTab}>
          <Tab
            tabIndex={0}
            label={
              <Typography
                variant={'body2'}
                color={getIsErrorTab(errors, [
                  'objectY.object',
                  'objectY.keyField',
                  'objectY.command',
                ])}
              >
                {t(`timeLinesCreateOrEdit.objectY.tabs.data`)}
              </Typography>
            }
          />
          <Tab label={t(`timeLinesCreateOrEdit.objectY.tabs.columns`)} tabIndex={1} />
          <Tab label={t(`timeLinesCreateOrEdit.objectY.tabs.actions`)} tabIndex={2} />
          {Boolean(watchObjectViewId) && Boolean(watchObjectYColumns?.length) && (
            <Tab label={t(`timeLinesCreateOrEdit.objectY.tabs.restrictions`)} tabIndex={3} />
          )}
        </Tabs>
      </Box>
      <TabPanel index={0} sx={{ p: 1 }} value={objectYCurrentTab}>
        <FormGenerator inputs={objectYInputs} mainGridSpacing={0} />
        {!!watchObjectYCommandCode && !!watchObjectYObject?.id && (
          <>
            <CommandParameters
              disableFieldType
              commandCode={watchObjectYCommandCode.id}
              containerSx={{ mb: 1 }}
              label={t('contextMenuCreate.addMenuPointModal.parameters.label')}
              labelWidth={120}
              name='objectY.getDataCommand.parameters'
              parametersMode='params'
              sourceCode={watchObjectYObject.id as string}
              sourceTitle={watchObjectYObject.label}
              typeSource={TYPES_SOURCE_OPTIONS.OBJECT}
            />

            <CommandParameters
              disableFieldType
              commandCode={watchObjectYCommandCode.id}
              containerSx={{ mb: 1 }}
              label={t('contextMenuCreate.addMenuPointModal.body.label')}
              labelWidth={120}
              name='objectY.getDataCommand.body'
              parametersMode='body'
              sourceCode={watchObjectYObject.id as string}
              sourceTitle={watchObjectYObject.label}
              typeSource={TYPES_SOURCE_OPTIONS.OBJECT}
            />
          </>
        )}
        <Prefilter
          hint={t('timeLinesCreateOrEdit.objectY.preFilterHint')}
          keyWordList={[]}
          value={watchObjectYPreFilter as string}
          keyWordObj={{
            pattern: REGEX.GLOBAL_VARIABLE,
            alias: 'global',
          }}
          onChange={handleChangeObjectYPreFilter}
        />
      </TabPanel>
      <TabPanel index={1} value={objectYCurrentTab}>
        <SwitchTable
          disablePagination
          showActionsColumn
          btnDisabled={!watchId}
          btnText={t(`timeLinesCreateOrEdit.addColumn`)}
          columns={TIMELINE_COLUMNS}
          rows={watchObjectYColumns}
          showDialog={objectYShowAddColumnDialog}
          type={MODEL_TYPE.TIMELINE_OBJECT_Y_COLUMN}
          onDelete={handleDeleteObjectYColumn}
          onShowDialog={handleOpenObjectYAddColumnDialog}
          onEdit={params => {
            handleOpenObjectYAddColumnDialog('edit', params.row.original.id)
          }}
        />
      </TabPanel>
      <TabPanel index={2} value={objectYCurrentTab}>
        <SwitchTable
          disablePagination
          showActionsColumn
          btnDisabled={!watchId}
          btnText={t(`timeLinesCreateOrEdit.addAction`)}
          columns={TIMELINE_ACTION_COLUMNS}
          rows={watchObjectYActions}
          showDialog={objectYShowAddActionDialog}
          type={MODEL_TYPE.TIMELINE_OBJECT_Y_ACTION}
          onDelete={handleDeleteObjectYAction}
          onShowDialog={handleOpenObjectYAddActionDialog}
          onEdit={params => {
            handleOpenObjectYAddActionDialog('edit', params.row.original.id)
          }}
        />
      </TabPanel>
      <TabPanel index={3} value={objectYCurrentTab}>
        <ConfigRestrictions
          hiddenColumns={['qs']}
          rows={watchObjectYColumns}
          viewId={watchObjectViewId as number}
        />
      </TabPanel>
    </>
  )
}
